<template>
  <div>
    <policy-header />
    <terms-policy />
    <policy-footer />
  </div>
</template>
<script>
import PolicyHeader from 'pages/policy-pages/components/header-policy';
import TermsPolicy from 'pages/policy-pages/terms/components/terms-policy';
import PolicyFooter from 'pages/policy-pages/components/footer-policy';

export default {
  components: {
    PolicyHeader,
    TermsPolicy,
    PolicyFooter,
  },
};
</script>
